import { render } from "./organisation-person-details.vue?vue&type=template&id=405d2032"
import script from "./organisation-person-details.vue?vue&type=script&lang=js"
export * from "./organisation-person-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__